/*
 * KLAIR: Upsell vor der Kasse (ersetzt Zipify OCU)
 * ------------------------------------------------
 * Beim Klick auf "Zur Kasse" im Drawer oder auf /cart erscheint einmal pro Sitzung ein
 * Angebot: Bild links, Text rechts. Schliessen nur ueber Annehmen oder Ablehnen, danach geht
 * es mit Ladeanzeige weiter in den Checkout.
 *
 * Woher was kommt:
 *   window.KlairUpsell    snippets/js-variables.liquid, aus dem Shop-Metafeld klair.upsell,
 *                         das das KLAIR Cockpit schreibt (Angebot, Texte, A/B-Anteile)
 *   KlairKassenTor        assets/cart-change-guard.js - haelt den Checkout an, bis das
 *                         Popup fertig ist, und schickt danach selbst ab
 *   Rabatt                Shopify Function klair-staffel, erkennt die Zeile an
 *                         _upsell = ocu:<testId>:<variante>
 *
 * Grundsatz: Das Popup darf niemanden an der Kasse aufhalten. Ist der Warenkorb nicht
 * lesbar oder scheitert das Hinzufuegen, geht es ohne Angebot weiter.
 *
 * Vorschau ohne Einschalten: ?klair_upsell=A (oder B) an eine Shop-URL haengen. Gilt fuer
 * diese Sitzung und zeigt das Popup bei jedem Klick; ?klair_upsell=aus beendet sie.
 *
 * Messung: view / annahme / ablehnung gehen per sendBeacon an den Messpunkt des Cockpits
 * (daten.messpunkt) - sendBeacon, weil die Seite gleich danach in den Checkout wechselt.
 * Die Vorschau meldet nichts. Zusaetzlich als document-Ereignis 'klair-upsell:ereignis'.
 */
(function () {
  const daten = window.KlairUpsell;
  const tor = window.KlairKassenTor;
  if (!daten || !tor || !Array.isArray(daten.varianten)) return;

  const SCHLUESSEL_GEZEIGT = 'klair_upsell_gezeigt';
  const SCHLUESSEL_VORSCHAU = 'klair_upsell_vorschau';
  const SCHLUESSEL_ZUTEILUNG = 'klair_upsell_zuteilung';
  const SCHLUESSEL_SITZUNG = 'klair_upsell_sitzung';
  const WARTEZEIT_MS = 4000;

  function lies(speicher, schluessel) {
    try {
      return window[speicher].getItem(schluessel);
    } catch (fehler) {
      return null;
    }
  }

  function schreib(speicher, schluessel, wert) {
    try {
      if (wert === null) window[speicher].removeItem(schluessel);
      else window[speicher].setItem(schluessel, wert);
    } catch (fehler) {
      /* privater Modus - dann eben ohne Gedaechtnis */
    }
  }

  const vorschauParameter = new URLSearchParams(window.location.search).get('klair_upsell');
  if (vorschauParameter) {
    schreib('sessionStorage', SCHLUESSEL_VORSCHAU, vorschauParameter === 'aus' ? null : vorschauParameter.toUpperCase());
  }

  function varianteMitId(id) {
    return (
      daten.varianten.find(function (v) {
        return v.id === id;
      }) || null
    );
  }

  // Einmal zugeteilt, bleibt ein Besucher bei seiner Variante - auch ueber Sitzungen hinweg,
  // solange dieselbe Testversion laeuft. Sonst saehe jemand heute A und morgen B.
  function zugeteilteVariante() {
    let gespeichert = null;
    try {
      gespeichert = JSON.parse(lies('localStorage', SCHLUESSEL_ZUTEILUNG) || 'null');
    } catch (fehler) {
      gespeichert = null;
    }
    if (gespeichert && gespeichert.testId === daten.testId && varianteMitId(gespeichert.variante)) {
      return varianteMitId(gespeichert.variante);
    }

    const summe = daten.varianten.reduce(function (s, v) {
      return s + Math.max(0, Number(v.gewicht) || 0);
    }, 0);
    let wurf = Math.random() * (summe || 1);
    let gewaehlt = daten.varianten[0];
    for (let i = 0; i < daten.varianten.length; i++) {
      wurf -= Math.max(0, Number(daten.varianten[i].gewicht) || 0);
      if (wurf < 0) {
        gewaehlt = daten.varianten[i];
        break;
      }
    }

    schreib('localStorage', SCHLUESSEL_ZUTEILUNG, JSON.stringify({ testId: daten.testId, variante: gewaehlt.id }));
    return gewaehlt;
  }

  // Zufaellige Kennung dieser Browser-Sitzung. Das Cockpit zaehlt damit jede Meldung pro
  // Sitzung nur einmal; sie verweist auf niemanden.
  function sitzung() {
    let id = lies('sessionStorage', SCHLUESSEL_SITZUNG);
    if (!id) {
      id =
        window.crypto && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID()
          : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
      schreib('sessionStorage', SCHLUESSEL_SITZUNG, id);
    }
    return id;
  }

  function melde(typ, variante, vorschau) {
    const detail = { typ: typ, testId: daten.testId, variante: variante.id };
    document.dispatchEvent(new CustomEvent('klair-upsell:ereignis', { detail: detail }));
    if (vorschau || !daten.messpunkt || typeof navigator.sendBeacon !== 'function') return;
    try {
      navigator.sendBeacon(daten.messpunkt, JSON.stringify(Object.assign({ sitzung: sitzung() }, detail)));
    } catch (fehler) {
      /* Messung darf den Checkout nie stoeren */
    }
  }

  function wurzel() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function mitFrist(url, optionen) {
    const abbruch = typeof AbortController === 'function' ? new AbortController() : null;
    const uhr = abbruch
      ? setTimeout(function () {
          abbruch.abort();
        }, WARTEZEIT_MS)
      : null;
    return fetch(url, Object.assign({ credentials: 'same-origin', signal: abbruch && abbruch.signal }, optionen)).finally(
      function () {
        if (uhr) clearTimeout(uhr);
      }
    );
  }

  async function leseWarenkorb() {
    try {
      const antwort = await mitFrist(wurzel() + 'cart.js', { headers: { Accept: 'application/json' } });
      return antwort.ok ? await antwort.json() : null;
    } catch (fehler) {
      return null;
    }
  }

  async function fuegeHinzu(variante, menge) {
    try {
      const antwort = await mitFrist(wurzel() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variante.variantId,
              quantity: menge,
              properties: { _upsell: 'ocu:' + daten.testId + ':' + variante.id }
            }
          ]
        })
      });
      return antwort.ok;
    } catch (fehler) {
      return false;
    }
  }

  /*
   * Geld im Format des Markts. Liquid gibt ein Beispiel ("CHF 1'234.56", "1.234,56 €"),
   * daraus stammen Waehrung und Trennzeichen - so bleibt die Formatierung beim Theme und
   * muss hier nicht nachgebaut werden.
   */
  const GELD = (function () {
    const treffer = /^(.*?)1(\D?)234(\D)56(.*)$/.exec(daten.geldMuster || '');
    return treffer
      ? { vor: treffer[1], tausend: treffer[2], dezimal: treffer[3], nach: treffer[4] }
      : { vor: '', tausend: '', dezimal: '.', nach: '' };
  })();

  function geld(rappen) {
    const betrag = Math.max(0, Math.round(rappen));
    const ganz = String(Math.floor(betrag / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, GELD.tausend);
    return GELD.vor + ganz + GELD.dezimal + String(betrag % 100).padStart(2, '0') + GELD.nach;
  }

  /** Buy X Get Y: Stueck je Satz, sonst null. */
  function satz(variante) {
    const kaufen = Number(variante.rabattKaufen);
    const gratis = Number(variante.rabattGratis);
    if (variante.rabattArt !== 'bxgy' || !(kaufen >= 1) || !(gratis >= 1)) return null;
    return { kaufen: kaufen, gratis: gratis, stueck: kaufen + gratis };
  }

  /*
   * Preise einer Variante in Rappen der Waehrung der Seite. Ein fester Betrag steht in
   * Shopwaehrung im Cockpit und wird wie in der Function mit dem Kurs umgerechnet
   * (Shopify.currency.rate) - sonst zeigte das Popup im EUR-Markt einen anderen Abzug,
   * als der Checkout gibt. Bei Buy X Get Y gilt der Preis fuer den ganzen Satz.
   */
  function preise(variante) {
    const einzel = Number(variante.preisRappen) || 0;
    const s = satz(variante);
    const preis = s ? einzel * s.stueck : einzel;
    const kurs = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    let abzug = 0;
    let rabattText = '';
    if (variante.rabattArt === 'prozent' && variante.rabattProzent > 0) {
      abzug = Math.round((preis * variante.rabattProzent) / 100);
      rabattText = daten.standard.rabatt.replace('__PROZENT__', variante.rabattProzent);
    } else if (variante.rabattArt === 'betrag' && variante.rabattBetrag > 0) {
      const betrag = Math.round(variante.rabattBetrag * kurs * 100);
      abzug = Math.min(preis, betrag);
      rabattText = daten.standard.rabattBetrag.replace('__BETRAG__', geld(betrag));
    } else if (s) {
      abzug = einzel * s.gratis;
      rabattText = (s.gratis === 1 ? daten.standard.rabattBxgyEins : daten.standard.rabattBxgyMehr).replace('__GRATIS__', s.gratis);
    }
    return { alt: abzug > 0 ? geld(preis) : '', neu: geld(preis - abzug), rabattText: rabattText };
  }

  function texte(variante) {
    const alle = variante.texte || {};
    const eigene = alle[daten.sprache] || {};
    const deutsch = alle.de || {};
    return {
      // Ueberschrift und Text: ohne Uebersetzung der deutsche Text, wie im Cockpit beschriftet.
      titel: eigene.titel || deutsch.titel || '',
      text: eigene.text || deutsch.text || '',
      // Produkttitel: eigener aus dem Cockpit, sonst der aus Shopify in der Sprache der Seite.
      produkt: eigene.produkt || deutsch.produkt || variante.produkt || '',
      // Knoepfe: ohne eigene Beschriftung die des Themes in der Sprache der Seite.
      annehmen: eigene.annehmen || daten.standard.annehmen,
      ablehnen: eigene.ablehnen || daten.standard.ablehnen
    };
  }

  const STIL = [
    '.klair-upsell{border:0;padding:0;width:min(50rem,calc(100vw - 1rem));max-width:none;max-height:calc(100dvh - 1rem);',
    'overflow:auto;border-radius:12px;background:rgb(var(--dialog-background,255 255 255));',
    'color:rgb(var(--text-primary,26 26 26));}',
    '.klair-upsell::backdrop{background:rgb(0 0 0/.5);}',
    '.klair-upsell__raster{display:grid;grid-template-columns:1fr 1fr;}',
    '.klair-upsell__bildrahmen{background:rgb(var(--text-primary,26 26 26)/.04);}',
    '.klair-upsell__bildrahmen{display:flex;align-items:center;}',
    '.klair-upsell__bild{display:block;width:100%;height:100%;object-fit:contain;}',
    '.klair-upsell__inhalt{padding:1.75rem 1.5rem;display:flex;flex-direction:column;gap:.75rem;}',
    '.klair-upsell__titel{margin:0;font-size:1.25rem;line-height:1.3;font-weight:700;}',
    '.klair-upsell__name{margin:0;font-weight:600;}',
    '.klair-upsell__text{margin:0;font-size:.875rem;white-space:pre-line;}',
    '.klair-upsell__preise{display:flex;flex-wrap:wrap;align-items:baseline;gap:.25rem .75rem;}',
    '.klair-upsell__alt{opacity:.6;}',
    '.klair-upsell__neu{font-weight:700;font-size:1.125rem;}',
    '.klair-upsell__rabatt{flex-basis:100%;font-size:.875rem;font-weight:600;color:rgb(var(--on-sale-text,227 44 43));}',
    '.klair-upsell__menge{align-self:flex-start;align-items:center;border-color:rgb(var(--text-primary,26 26 26)/.15);}',
    '.klair-upsell__menge .quantity-selector__button{display:flex;align-items:center;height:100%;}',
    '.klair-upsell__menge .quantity-selector__button:disabled{opacity:.3;cursor:default;}',
    '.klair-upsell__menge .quantity-selector__input{display:flex;align-items:center;justify-content:center;min-width:1.5rem;width:auto;}',
    '.klair-upsell__knoepfe{margin-top:auto;padding-top:.75rem;display:grid;gap:.75rem;}',
    /*
     * Handy: Bild oben. Das Popup ist hoechstens so hoch wie der Bildschirm; Text und
     * Knoepfe behalten ihre Hoehe, das Bild nimmt den Rest. Auf grossen Handys steht es
     * in voller Groesse, auf kleinen schrumpft es - bis 9rem, darunter wuerde man es
     * nicht mehr erkennen. Reicht selbst das nicht (sehr kleine Bildschirme), scrollt das
     * Popup. Eine feste Hoehe war auf grossen Handys zu klein und auf kleinen schob sie
     * die Knoepfe aus dem Bild.
     */
    '@media (max-width:699px){.klair-upsell{overflow:hidden;}',
    '.klair-upsell__raster{display:flex;flex-direction:column;max-height:calc(100dvh - 1rem);overflow-y:auto;}',
    // Das Bild selbst schrumpft, nicht ein Rahmen darum - sonst schnitte der Rahmen es ab.
    '.klair-upsell__bildrahmen{display:contents;}',
    '.klair-upsell__bild{flex:0 1 auto;min-height:9rem;width:100%;height:auto;object-fit:contain;',
    'background:rgb(var(--text-primary,26 26 26)/.04);}',
    '.klair-upsell__inhalt{flex:0 0 auto;padding:1rem 1.25rem 1.25rem;gap:.5rem;}',
    '.klair-upsell__titel{font-size:1.25rem;}',
    '.klair-upsell__name{font-size:1.125rem;}',
    '.klair-upsell__rabatt{font-size:1rem;}',
    '.klair-upsell__knoepfe{padding-top:.5rem;gap:.5rem;}}'
  ].join('');

  function stilEinmal() {
    if (document.getElementById('klair-upsell-stil')) return;
    const stil = document.createElement('style');
    stil.id = 'klair-upsell-stil';
    stil.textContent = STIL;
    document.head.appendChild(stil);
  }

  function element(tag, klasse, text) {
    const el = document.createElement(tag);
    if (klasse) el.className = klasse;
    if (text) el.textContent = text;
    return el;
  }

  /*
   * Gewoehnlicher Knopf; aria-busy="true" zeigt den Lade-Ring aus theme.css (KLAIR-Regel bei
   * .button__loader). Der Text steckt in einem span, weil die Regel die Kinder des Knopfs
   * ausblendet - reiner Text bliebe sichtbar.
   *
   * Bewusst nicht Impacts is="custom-button": Das ist ein "customized built-in" Element, das
   * Safari nur per Polyfill kennt, und bei per Skript erzeugten Knoepfen greift der nicht.
   */
  function knopf(klasse, text) {
    const k = document.createElement('button');
    k.type = 'button';
    k.className = klasse;
    k.appendChild(element('span', '', text));
    return k;
  }

  /*
   * Offene Drawer (Impact dialog-element) haengen an einer focus-trap. Die schliesst den
   * Drawer bei jedem Klick ausserhalb - auch bei Klicks in dieses Popup, das nicht im
   * Drawer liegt. Die Falle nur zu pausieren reichte nicht: gemessen lief die
   * Klick-Pruefung trotzdem weiter.
   *
   * Entschieden wird in Impacts _allowOutsideClickMouse/-Touch, und die ruft die Falle
   * ueber `this` auf - an der Instanz ueberschrieben greift es also. Solange das Popup
   * offen ist, schliesst kein Klick den Drawer; der Hintergrund ist ohnehin gesperrt.
   * Die Pause bleibt fuer den Fokus: sonst zoege die Falle ihn aus dem Popup zurueck.
   * Escape faengt das Popup selbst ab (siehe zeigeDialog).
   */
  function schuetzeOffeneDrawer() {
    const rueckbau = [];
    const ohneSchliessen = function () {
      return true;
    };
    document.querySelectorAll('[open]').forEach(function (el) {
      if (typeof el._allowOutsideClickMouse !== 'function') return;
      el._allowOutsideClickMouse = ohneSchliessen;
      el._allowOutsideClickTouch = ohneSchliessen;
      const falle = el._focusTrap;
      const pausiert = !!(falle && falle.active && !falle.paused && typeof falle.pause === 'function');
      if (pausiert) falle.pause();
      rueckbau.push(function () {
        // Instanz-Eigenschaften entfernen - dann gilt wieder die Methode des Prototyps.
        delete el._allowOutsideClickMouse;
        delete el._allowOutsideClickTouch;
        if (pausiert && falle.active && falle.paused) falle.unpause();
      });
    });
    return function aufheben() {
      rueckbau.forEach(function (f) {
        f();
      });
    };
  }

  /*
   * Zeigt das Angebot und loest mit 'annahme', 'ablehnung' oder 'fehler' auf.
   *
   * Schliessen laesst es sich nur ueber die beiden Knoepfe. Danach bleibt es mit
   * Ladeanzeige stehen, bis der Checkout die Seite abloest - sonst saehe man kurz den
   * Warenkorb, obwohl es schon weitergeht.
   */
  function zeigeDialog(variante, vorschau) {
    stilEinmal();
    const t = texte(variante);
    const maxMenge = Math.max(1, Number(variante.maxMenge) || 1);
    let menge = 1;

    const dialog = element('dialog', 'klair-upsell');
    dialog.setAttribute('aria-labelledby', 'klair-upsell-titel');
    const raster = element('div', 'klair-upsell__raster');

    if (variante.bild) {
      const rahmen = element('div', 'klair-upsell__bildrahmen');
      const bild = element('img', 'klair-upsell__bild');
      bild.src = variante.bild;
      bild.alt = t.produkt;
      rahmen.appendChild(bild);
      raster.appendChild(rahmen);
    }

    const inhalt = element('div', 'klair-upsell__inhalt');
    const titel = element('p', 'klair-upsell__titel', t.titel);
    titel.id = 'klair-upsell-titel';
    inhalt.appendChild(titel);
    inhalt.appendChild(element('p', 'klair-upsell__name', t.produkt));
    if (t.text) inhalt.appendChild(element('p', 'klair-upsell__text', t.text));

    const p = preise(variante);
    const preiszeile = element('div', 'klair-upsell__preise');
    if (p.alt) preiszeile.appendChild(element('s', 'klair-upsell__alt', p.alt));
    preiszeile.appendChild(element('span', 'klair-upsell__neu', p.neu));
    if (p.rabattText) preiszeile.appendChild(element('span', 'klair-upsell__rabatt', p.rabattText));
    inhalt.appendChild(preiszeile);

    // Mengenwahl in der Optik des Themes (.quantity-selector wie im Warenkorb). Bei einem
    // Maximum von 1 gibt es nichts zu waehlen - dann faellt sie ganz weg, statt mit
    // gesperrtem Plus kaputt auszusehen.
    const mengenwahl = element('div', 'quantity-selector klair-upsell__menge');
    const weniger = element('button', 'quantity-selector__button');
    weniger.type = 'button';
    weniger.setAttribute('aria-label', daten.standard.weniger);
    weniger.innerHTML =
      '<svg role="presentation" focusable="false" width="10" height="2" viewBox="0 0 10 2"><path d="M0 0H10V2H0V0Z" fill="currentColor"></path></svg>';
    const anzeige = element('output', 'quantity-selector__input', '1');
    const mehr = element('button', 'quantity-selector__button');
    mehr.type = 'button';
    mehr.setAttribute('aria-label', daten.standard.mehr);
    mehr.innerHTML =
      '<svg role="presentation" focusable="false" stroke-width="2" width="10" height="10" viewBox="0 0 12 12"><path d="M6 0V12" fill="none" stroke="currentColor"></path><path d="M0 6L12 6" fill="none" stroke="currentColor"></path></svg>';
    mengenwahl.appendChild(weniger);
    mengenwahl.appendChild(anzeige);
    mengenwahl.appendChild(mehr);
    // Im Cockpit ausschaltbar; bei einem Maximum von 1 gibt es ohnehin nichts zu waehlen.
    // Bei Buy X Get Y ist die Menge der Satz selbst - eine Mengenwahl daneben verwirrte.
    if (variante.mengenwahl !== false && maxMenge > 1 && !satz(variante)) inhalt.appendChild(mengenwahl);

    function zeigeMenge() {
      anzeige.textContent = String(menge);
      weniger.disabled = menge <= 1;
      mehr.disabled = menge >= maxMenge;
    }
    zeigeMenge();
    weniger.addEventListener('click', function () {
      menge = Math.max(1, menge - 1);
      zeigeMenge();
    });
    mehr.addEventListener('click', function () {
      menge = Math.min(maxMenge, menge + 1);
      zeigeMenge();
    });

    const annehmen = knopf('button button--xl w-full', t.annehmen);
    const ablehnen = knopf('button button--xl button--outline w-full', t.ablehnen);
    const knoepfe = element('div', 'klair-upsell__knoepfe');
    knoepfe.appendChild(annehmen);
    knoepfe.appendChild(ablehnen);
    inhalt.appendChild(knoepfe);

    raster.appendChild(inhalt);
    dialog.appendChild(raster);
    document.body.appendChild(dialog);

    const aufheben = schuetzeOffeneDrawer();

    function entferne() {
      if (dialog.open) dialog.close();
      dialog.remove();
      aufheben();
    }

    // Zurueck aus dem Checkout holt die Seite aus dem Browser-Cache - samt Popup mit
    // laufender Ladeanzeige. Bleibt der Checkout aus (z. B. weil gerade eine Warenkorb-
    // Aenderung laeuft und die Sperre greift), gibt die Notbremse die Seite wieder frei.
    function entferneSpaeter() {
      window.addEventListener('pageshow', entferne, { once: true });
      setTimeout(entferne, 8000);
    }

    return new Promise(function (fertig) {
      let entschieden = false;

      function beschaeftigt(geklickt) {
        entschieden = true;
        [annehmen, ablehnen, weniger, mehr].forEach(function (k) {
          k.disabled = true;
        });
        geklickt.setAttribute('aria-busy', 'true');
      }

      annehmen.addEventListener('click', async function () {
        if (entschieden) return;
        beschaeftigt(annehmen);
        melde('annahme', variante, vorschau);
        const s = satz(variante);
        const geklappt = await fuegeHinzu(variante, s ? s.stueck : menge);
        entferneSpaeter();
        fertig(geklappt ? 'annahme' : 'fehler');
      });
      ablehnen.addEventListener('click', function () {
        if (entschieden) return;
        beschaeftigt(ablehnen);
        melde('ablehnung', variante, vorschau);
        entferneSpaeter();
        fertig('ablehnung');
      });
      // Escape schliesst einen modalen Dialog sonst von selbst. Und bis zum Dokument
      // durchgereicht, schliesst die focus-trap des Drawers ihn trotz Pause - gemessen.
      dialog.addEventListener('cancel', function (ereignis) {
        ereignis.preventDefault();
      });
      dialog.addEventListener('keydown', function (ereignis) {
        if (ereignis.key === 'Escape') ereignis.stopPropagation();
      });

      dialog.showModal();
      melde('view', variante, vorschau);
    });
  }

  async function biete(variante, vorschau) {
    const warenkorb = await leseWarenkorb();
    if (!warenkorb || !Array.isArray(warenkorb.items) || warenkorb.items.length === 0) return;

    // Wer das Produkt schon im Warenkorb hat, bekommt es nicht noch einmal angeboten.
    const schonDrin = warenkorb.items.some(function (zeile) {
      return zeile.variant_id === variante.variantId;
    });
    if (schonDrin) return;

    if (!vorschau) schreib('sessionStorage', SCHLUESSEL_GEZEIGT, daten.testId);
    await zeigeDialog(variante, vorschau);
  }

  tor.schritt('upsell', 20, function () {
    const vorschauId = lies('sessionStorage', SCHLUESSEL_VORSCHAU);
    const vorschau = vorschauId ? varianteMitId(vorschauId) : null;

    if (!vorschau) {
      if (daten.aktiv !== true) return;
      if (lies('sessionStorage', SCHLUESSEL_GEZEIGT) === daten.testId) return;
    }

    const variante = vorschau || zugeteilteVariante();
    if (!variante || !variante.verfuegbar) return;
    if (typeof HTMLDialogElement !== 'function') return;

    return biete(variante, !!vorschau);
  });
})();
